import { useEffect, useState } from "react";
import { FormModal, Input } from "@marekl/adminer/components";
import {
  useCreatePanel,
  useRenamePanel,
  type Panel,
} from "../../../lib/queries/panels";
import type { ID } from "../../../lib/id";

interface PanelNameModalProps {
  competitionId: ID;
  running: boolean;
  /** "new" to create a panel, a panel to rename it, null when closed. */
  target: Panel | "new" | null;
  onClose: () => void;
}

// Creates a panel or renames one. An empty name on create lets the server
// number it („Porota 3").
export function PanelNameModal({
  competitionId,
  running,
  target,
  onClose,
}: PanelNameModalProps) {
  const create = useCreatePanel(competitionId, running);
  const rename = useRenamePanel(competitionId);
  const [name, setName] = useState("");

  useEffect(() => {
    if (target) {
      setName(target === "new" ? "" : target.name);
      create.reset();
      rename.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset when another panel is opened
  }, [target]);

  if (!target) return null;
  const mutation = target === "new" ? create : rename;

  return (
    <FormModal
      open
      title={target === "new" ? "Nová porota" : "Přejmenovat porotu"}
      error={mutation.error}
      busy={mutation.isPending}
      canSubmit={target === "new" || name.trim() !== ""}
      onSubmit={() =>
        target === "new"
          ? create.mutate(name.trim(), { onSuccess: onClose })
          : rename.mutate(
              { id: target.id, name: name.trim() },
              { onSuccess: onClose },
            )
      }
      onClose={onClose}
    >
      <Input
        label="Název"
        value={name}
        placeholder={target === "new" ? "Např. Porota TD" : undefined}
        onChange={(e) => setName(e.target.value)}
      />
    </FormModal>
  );
}
